import { MetricConverter } from './helpers';

const thermalResistivityUnits = ['Km/W'] as const;
type ThermalResistivityUnit = (typeof thermalResistivityUnits)[number];

class ThermalResistivityConverter extends MetricConverter<ThermalResistivityUnit, 'Km/W'> {
    baseUnit = 'Km/W' as const;
    units = thermalResistivityUnits;
}

export { ThermalResistivityConverter };
